











import { computed, defineComponent } from "@vue/composition-api";
import { Message, MessageAttachment } from "@scrile/api-provider/dist/api/MessagesProvider";
import { BlockingStatus } from "@/types";
import BaseIcon from "@/components/BaseIcon";
import MessageMediaGallery from "./MessageMediaGallery.vue";

export default defineComponent({
  name: "MessageItemAttachment",
  components: { MessageMediaGallery, BaseIcon },
  props: {
    message: { type: Object as () => Message, required: true },
    available: { type: Boolean, required: true },
    authUserId: { type: String, required: true },
    price: { type: String, required: true },
    blockingStatus: { type: Object as () => BlockingStatus, required: true },
  },
  setup(props, { emit }) {
    const isAuthor = computed(() => props.message.senderId === props.authUserId);

    const onUnlock = () => {
      if (
        props.message.attachment.every((attachment: MessageAttachment) => attachment.file.processingStatus !== "ERROR")
      ) {
        emit("click");
        return;
      }
    };

    return {
      isAuthor,
      onUnlock,
    };
  },
});
